module.exports = __webpack_public_path__ + "7441a4a975aea8fed1bb3b2dfdaa06aa.svg";